module.exports = __webpack_public_path__ + "static/media/1.5428bb27.png";